// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ISse2","label":"CategoryService_label__ZuoZ9","location":"CategoryService_location__36gOy"};